import * as d from "react";
import { useResizeListener as We, useOverlayScrollListener as $e, useMountEffect as je, useUpdateEffect as B, useUnmountEffect as ke, Portal as Ze, PrimeReact as ce } from "./portal.esm.79076359.js";
import { jsx as U, DomHandler as m, ZIndexUtils as P, ObjectUtils as fe, classNames as Be, jsxs as Ue } from "./utils.esm.ea524c19.js";
function Fe(t, s, l) {
  return s in t ? Object.defineProperty(t, s, {
    value: l,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[s] = l, t;
}
function F(t, s) {
  (s == null || s > t.length) && (s = t.length);
  for (var l = 0, E = new Array(s); l < s; l++)
    E[l] = t[l];
  return E;
}
function Xe(t) {
  if (Array.isArray(t))
    return F(t);
}
function Ye(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function de(t, s) {
  if (!!t) {
    if (typeof t == "string")
      return F(t, s);
    var l = Object.prototype.toString.call(t).slice(8, -1);
    if (l === "Object" && t.constructor && (l = t.constructor.name), l === "Map" || l === "Set")
      return Array.from(t);
    if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l))
      return F(t, s);
  }
}
function Ke() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ve(t) {
  return Xe(t) || Ye(t) || de(t) || Ke();
}
function qe(t) {
  if (Array.isArray(t))
    return t;
}
function ze(t, s) {
  var l = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (l != null) {
    var E = [], v = !0, b = !1, S, T;
    try {
      for (l = l.call(t); !(v = (S = l.next()).done) && (E.push(S.value), !(s && E.length === s)); v = !0)
        ;
    } catch (g) {
      b = !0, T = g;
    } finally {
      try {
        !v && l.return != null && l.return();
      } finally {
        if (b)
          throw T;
      }
    }
    return E;
  }
}
function Ge() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function w(t, s) {
  return qe(t) || ze(t, s) || de(t, s) || Ge();
}
var X = /* @__PURE__ */ d.memo(/* @__PURE__ */ d.forwardRef(function(t, s) {
  var l = d.useState(!1), E = w(l, 2), v = E[0], b = E[1], S = d.useState(t.position), T = w(S, 2), g = T[0], N = T[1], ve = d.useState(""), Y = w(ve, 2), he = Y[0], K = Y[1], a = d.useRef(null), x = d.useRef(null), o = d.useRef(null), R = d.useRef(null), O = d.useRef(!0), V = d.useRef({}), q = d.useRef(null), me = We({
    listener: function(e) {
      !m.isTouchDevice() && p(e);
    }
  }), z = w(me, 2), ye = z[0], Ee = z[1], pe = $e({
    target: o.current,
    listener: function(e) {
      p(e);
    },
    when: v
  }), G = w(pe, 2), be = G[0], Te = G[1], ge = function(e) {
    return !(t.content || f(e, "tooltip"));
  }, we = function(e) {
    return !(t.content || f(e, "tooltip") || t.children);
  }, W = function(e) {
    return f(e, "mousetrack") || t.mouseTrack;
  }, J = function(e) {
    return f(e, "disabled") === "true" || ee(e, "disabled") || t.disabled;
  }, Q = function(e) {
    return f(e, "showondisabled") || t.showOnDisabled;
  }, C = function() {
    return f(o.current, "autohide") || t.autoHide;
  }, f = function(e, n) {
    return ee(e, "data-pr-".concat(n)) ? e.getAttribute("data-pr-".concat(n)) : null;
  }, ee = function(e, n) {
    return e && e.hasAttribute(n);
  }, te = function(e) {
    var n = [f(e, "showevent") || t.showEvent], i = [f(e, "hideevent") || t.hideEvent];
    if (W(e))
      n = ["mousemove"], i = ["mouseleave"];
    else {
      var u = f(e, "event") || t.event;
      u === "focus" && (n = ["focus"], i = ["blur"]), u === "both" && (n = ["focus", "mouseenter"], i = ["blur", "mouseleave"]);
    }
    return {
      showEvents: n,
      hideEvents: i
    };
  }, Se = function(e) {
    return f(e, "position") || g;
  }, xe = function(e) {
    var n = f(e, "mousetracktop") || t.mouseTrackTop, i = f(e, "mousetrackleft") || t.mouseTrackLeft;
    return {
      top: n,
      left: i
    };
  }, ne = function(e, n) {
    if (x.current) {
      var i = f(e, "tooltip") || t.content;
      i ? (x.current.innerHTML = "", x.current.appendChild(document.createTextNode(i)), n()) : t.children && n();
    }
  }, re = function(e) {
    ne(o.current, function() {
      var n = q.current, i = n.pageX, u = n.pageY;
      t.autoZIndex && !P.get(a.current) && P.set("tooltip", a.current, ce.autoZIndex, t.baseZIndex || ce.zIndex.tooltip), a.current.style.left = "", a.current.style.top = "", C() && (a.current.style.pointerEvents = "none"), W(o.current) && !R.current && (R.current = {
        width: m.getOuterWidth(a.current),
        height: m.getOuterHeight(a.current)
      }), ie(o.current, {
        x: i,
        y: u
      }, e);
    });
  }, A = function(e) {
    o.current = e.currentTarget;
    var n = J(o.current), i = we(Q(o.current) && n ? o.current.firstChild : o.current);
    if (!(i || n))
      if (q.current = e, v)
        L("updateDelay", re);
      else {
        var u = D(t.onBeforeShow, {
          originalEvent: e,
          target: o.current
        });
        u && L("showDelay", function() {
          b(!0), D(t.onShow, {
            originalEvent: e,
            target: o.current
          });
        });
      }
  }, p = function(e) {
    if ($(), v) {
      var n = D(t.onBeforeHide, {
        originalEvent: e,
        target: o.current
      });
      n && L("hideDelay", function() {
        !C() && O.current === !1 || (P.clear(a.current), m.removeClass(a.current, "p-tooltip-active"), b(!1), D(t.onHide, {
          originalEvent: e,
          target: o.current
        }));
      });
    }
  }, ie = function(e, n, i) {
    var u = 0, c = 0, h = i || g;
    if (W(e) && n) {
      var y = {
        width: m.getOuterWidth(a.current),
        height: m.getOuterHeight(a.current)
      };
      u = n.x, c = n.y;
      var oe = xe(e), _ = oe.top, M = oe.left;
      switch (h) {
        case "left":
          u -= y.width + M, c -= y.height / 2 - _;
          break;
        case "right":
          u += M, c -= y.height / 2 - _;
          break;
        case "top":
          u -= y.width / 2 - M, c -= y.height + _;
          break;
        case "bottom":
          u -= y.width / 2 - M, c += _;
          break;
      }
      u <= 0 || R.current.width > y.width ? (a.current.style.left = "0px", a.current.style.right = window.innerWidth - y.width - u + "px") : (a.current.style.right = "", a.current.style.left = u + "px"), a.current.style.top = c + "px", m.addClass(a.current, "p-tooltip-active");
    } else {
      var j = m.findCollisionPosition(h), _e = f(e, "my") || t.my || j.my, Me = f(e, "at") || t.at || j.at;
      a.current.style.padding = "0px", m.flipfitCollision(a.current, e, _e, Me, function(k) {
        var le = k.at, Z = le.x, Pe = le.y, Ne = k.my.x, se = t.at ? Z !== "center" && Z !== Ne ? Z : Pe : k.at["".concat(j.axis)];
        a.current.style.padding = "", N(se), Re(se), m.addClass(a.current, "p-tooltip-active");
      });
    }
  }, Re = function(e) {
    if (a.current) {
      var n = getComputedStyle(a.current);
      e === "left" ? a.current.style.left = parseFloat(n.left) - parseFloat(n.paddingLeft) * 2 + "px" : e === "top" && (a.current.style.top = parseFloat(n.top) - parseFloat(n.paddingTop) * 2 + "px");
    }
  }, Oe = function() {
    C() || (O.current = !1);
  }, Ce = function(e) {
    C() || (O.current = !0, p(e));
  }, Ae = function(e) {
    if (e) {
      var n = te(e), i = n.showEvents, u = n.hideEvents, c = ae(e);
      i.forEach(function(h) {
        return c.addEventListener(h, A);
      }), u.forEach(function(h) {
        return c.addEventListener(h, p);
      });
    }
  }, Le = function(e) {
    if (e) {
      var n = te(e), i = n.showEvents, u = n.hideEvents, c = ae(e);
      i.forEach(function(h) {
        return c.removeEventListener(h, A);
      }), u.forEach(function(h) {
        return c.removeEventListener(h, p);
      });
    }
  }, L = function(e, n) {
    $();
    var i = f(o.current, e.toLowerCase()) || t[e];
    i ? V.current["".concat(e)] = setTimeout(function() {
      return n();
    }, i) : n();
  }, D = function(e) {
    if (e) {
      for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), u = 1; u < n; u++)
        i[u - 1] = arguments[u];
      var c = e.apply(void 0, i);
      return c === void 0 && (c = !0), c;
    }
    return !0;
  }, $ = function() {
    Object.values(V.current).forEach(function(e) {
      return clearTimeout(e);
    });
  }, ae = function(e) {
    if (e) {
      if (Q(e)) {
        if (e.hasWrapper)
          return e.parentElement;
        var n = document.createElement("span");
        return e.parentNode.insertBefore(n, e), n.appendChild(e), e.hasWrapper = !0, n;
      } else if (e.hasWrapper) {
        var i;
        (i = e.parentElement).replaceWith.apply(i, Ve(e.parentElement.childNodes)), delete e.hasWrapper;
      }
      return e;
    }
    return null;
  }, De = function(e) {
    I(e), H(e);
  }, H = function(e) {
    ue(e || t.target, Ae);
  }, I = function(e) {
    ue(e || t.target, Le);
  }, ue = function(e, n) {
    if (e = fe.getRefElement(e), e)
      if (m.isElement(e))
        n(e);
      else {
        var i = function(c) {
          var h = m.find(document, c);
          h.forEach(function(y) {
            n(y);
          });
        };
        e instanceof Array ? e.forEach(function(u) {
          i(u);
        }) : i(e);
      }
  };
  d.useEffect(function() {
    v && o.current && J(o.current) && p();
  }), je(function() {
    H();
  }), B(function() {
    return H(), function() {
      I();
    };
  }, [A, p, t.target]), B(function() {
    if (v) {
      var r = Se(o.current), e = f(o.current, "classname");
      N(r), K(e), re(r), ye(), be();
    } else
      N(t.position), K(""), o.current = null, R.current = null, O.current = !0;
    return function() {
      Ee(), Te();
    };
  }, [v]), B(function() {
    v && L("updateDelay", function() {
      ne(o.current, function() {
        ie(o.current);
      });
    });
  }, [t.content]), ke(function() {
    $(), I(), P.clear(a.current);
  }), d.useImperativeHandle(s, function() {
    return {
      props: t,
      updateTargetEvents: De,
      loadTargetEvents: H,
      unloadTargetEvents: I,
      show: A,
      hide: p,
      getElement: function() {
        return a.current;
      },
      getTarget: function() {
        return o.current;
      }
    };
  });
  var He = function() {
    var e = fe.findDiffKeys(t, X.defaultProps), n = Be("p-tooltip p-component", Fe({}, "p-tooltip-".concat(g), !0), t.className, he), i = ge(o.current);
    return /* @__PURE__ */ Ue("div", {
      id: t.id,
      ref: a,
      className: n,
      style: t.style,
      role: "tooltip",
      "aria-hidden": v,
      ...e,
      onMouseEnter: Oe,
      onMouseLeave: Ce,
      children: [/* @__PURE__ */ U("div", {
        className: "p-tooltip-arrow"
      }), /* @__PURE__ */ U("div", {
        ref: x,
        className: "p-tooltip-text",
        children: i && t.children
      })]
    });
  };
  if (v) {
    var Ie = He();
    return /* @__PURE__ */ U(Ze, {
      element: Ie,
      appendTo: t.appendTo,
      visible: !0
    });
  }
  return null;
}));
X.displayName = "Tooltip";
X.defaultProps = {
  __TYPE: "Tooltip",
  id: null,
  target: null,
  content: null,
  disabled: !1,
  className: null,
  style: null,
  appendTo: null,
  position: "right",
  my: null,
  at: null,
  event: null,
  showEvent: "mouseenter",
  hideEvent: "mouseleave",
  autoZIndex: !0,
  baseZIndex: 0,
  mouseTrack: !1,
  mouseTrackTop: 5,
  mouseTrackLeft: 5,
  showDelay: 0,
  updateDelay: 0,
  hideDelay: 0,
  autoHide: !0,
  showOnDisabled: !1,
  onBeforeShow: null,
  onBeforeHide: null,
  onShow: null,
  onHide: null
};
export {
  X as Tooltip
};
